import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ['nameField', 'idField', 'address', 'fiscalid'];
  } 

  connect() {
    let options = {
      url: function(phrase) {
        return "/subjects.json?q[first_name_or_last_name_or_business_name_cont]=" + phrase;
      },
      getValue: "name",
    	template: {
    		type: "custom",
    		method: function(value, item) {
    			return "<span>" + item.name + "</span></br><small class=\"text-muted\">" + item.fiscalid + "</small>";
    		}
    	},
      list: {
        match: {
          enabled: true
        },
        onChooseEvent: ()=> { this.subjectChosen() }
      },
      theme: "bootstrap",
    };

    $(this.nameFieldTarget).easyAutocomplete(options);
  }
  
  subjectChosen(){
    var chosen = $(this.nameFieldTarget).getSelectedItemData();
    $(this.idFieldTarget).val(chosen.id);
    if (this.hasAddressTarget) {
      $(this.addressTarget).html(`Indirizzo sede/residenza: ${chosen.address_sentence}`);
    }
    if (this.hasFiscalidTarget) {
      $(this.fiscalidTarget).html(`C.F./P.IVA: ${chosen.fiscalid}`);
    }
  }

}
